import React from 'react'

class ChangeStyleQR extends React.Component {

  state = {
    QRstyle: "QRCustom",    
  };

  
handleChange = (event) => {
	const {value} = event.target
    this.setState({ QRstyle: value })
	this.props.updateData(value);
  };


render() {
		return (
			<div className="style-picker" role="group" aria-label="Варианты оформления QR">
				<h4 className="style-picker__title style-picker__title--top">
					Параметры дизайна. Выберите стиль QR кода (доступно 7 вариантов).
				</h4>
				<div className="style-picker__grid">
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRCustom"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
							defaultChecked
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_A1.svg"
							alt=""
						/>
						<p className="style-picker__label">v1 настраиваемый стиль</p>
					</label>
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRNormal"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_A1.svg"
							alt=""
						/>
						<p className="style-picker__label">v2 с логотипом в центре</p>
					</label>
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRResImage"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_C2.svg"
							alt=""
						/>
						<p className="style-picker__label">v3 с рисунком внутри</p>
					</label>
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRBubble"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_SP_3.svg"
							alt=""
						/>
						<p className="style-picker__label">v4 с пузырями</p>
					</label>
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRDsj"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_SP-1.svg"
							alt=""
						/>
						<p className="style-picker__label">v5 гравировка ручной работы</p>
					</label>
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRLine"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_A-a1.svg"
							alt=""
						/>
						<p className="style-picker__label">v6 дополнительные направления</p>
					</label>
					<label className="style-picker__option">
						<input
							type="radio"
							name="QRstyle"
							value="QRRandRect"
							className="style-picker__radio"
							onChange={this.handleChange.bind(this)}
						/>
						<img
							className="style-picker__thumb"
							src="https://sbqr.ru/img/qrstyle/QRcode_SP_2.svg"
							alt=""
						/>
						<p className="style-picker__label">v7 случайные кубики</p>
					</label>
				</div>
			</div>
		)
}

}
export default ChangeStyleQR
